import type { AssetDetail } from "@/hooks/useAssetDetail";

/**
 * Optional 3D preview URL. Sellers can tag `preview-glb:<absolute https URL>` until
 * a dedicated column exists in the API.
 */
export function getAssetPreviewModelUrl(asset: AssetDetail): string | null {
  for (const tag of asset.tags ?? []) {
    const prefix = "preview-glb:";
    if (tag.startsWith(prefix)) {
      const url = tag.slice(prefix.length).trim();
      if (url.startsWith("https://")) return url;
    }
  }
  return null;
}
